/* eslint react-native/no-unused-styles: 0 */
import { Spinner, Text, View } from '@gluestack-ui/themed'
import React, { FunctionComponent, useEffect } from 'react'
import { StyleSheet } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { ActualiteItemResult } from '../../api/GridPage/types'
import { i18n } from '../../lib/i18n'
import { GridPageActions } from '../../redux/gridPage/actions'
import { actualiteSelector } from '../../redux/gridPage/selector'
import { isLoadingSelector } from '../../redux/loading/selectors'
import { LoaderName } from '../../redux/loading/types'
import { RootState } from '../../redux/reducers'
import { readableTextColor } from '../../services/theme'
import { theme } from '../../theme'
import { CardsLine } from './components/CardsLine.component'

interface GridPageActualitesProps {
  id: number
  bgColor?: string
}

const HEIGHT = 120

const mapCardsLineProp = (items: ActualiteItemResult[]) => ({
  items,
  height: HEIGHT,
})

export const GridPageActualites: FunctionComponent<GridPageActualitesProps> = props => {
  const dispatch = useDispatch()

  const actualites = useSelector((state: RootState) => actualiteSelector(state, props.id))
  const isLoading = useSelector((state: RootState) => isLoadingSelector(state, LoaderName.LOAD_GRID_ACTUALITES))

  useEffect(() => {
    dispatch(GridPageActions.loadActualites(props.id))
  }, [props.id])

  if (isLoading) {
    return <Spinner />
  }

  const items = (actualites && actualites.items) || []

  return (
    <View style={styles.content}>
      <Text style={{ color: readableTextColor(props.bgColor) }}>{i18n.t('gridActu.lastActu')}</Text>
      <View style={styles.lines}>
        <CardsLine {...mapCardsLineProp(items)} />
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  content: {
    paddingLeft: theme.padding.x1,
    marginTop: theme.padding.x3,
  },
  lines: {
    flex: 1,
    padding: theme.padding.x1,
  },
})
